import { ReactElement } from "react";
import {
  FaBullhorn,
  FaGauge,
  FaHeadset,
  FaRegRectangleList,
  FaUserGroup,
  FaUserTie,
} from "react-icons/fa6";
import UserTable from "./pages/user";
import PromotionManagement from "./pages/promotion";
import PublicationManagement from "./pages/publication";
import ManageCms from "./pages/cms";
import OtherService from "./pages/otherServices";
import ContactUs from "./pages/contactUs";
import Dashboard from "./pages/dashboard";
import OrderRequests from "./pages/order-requests";
import CreditLimitRequests from "./pages/credit-limit-requests";
import CreditSegmentCode from "./pages/creditSegmentCode";
import Chat from "./pages/chat";
import OrderReviews from "./pages/order-reviews";
import ReturnSalesOrder from "./pages/return-sales-order";
import SapConfig from "./pages/sap-config";
import NotificationConfig from "./pages/notificationConfig";
import { FcDataConfiguration } from "react-icons/fc";
import { FaEnvelope } from "react-icons/fa6";
import { CiMedicalCase } from "react-icons/ci";
import { MdRemoveRedEye } from "react-icons/md";
import { BsReverseLayoutTextWindowReverse } from "react-icons/bs";
import { MdCreditScore } from "react-icons/md";
import { PiLineSegments } from "react-icons/pi";
import { RiMessage2Line } from "react-icons/ri";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { BsBlockquoteRight } from "react-icons/bs";
import { FaRegUser } from "react-icons/fa";
import { BsBook } from "react-icons/bs";
import RolesManagement from "./pages/roles";
import StaffTable from "./pages/staffs";
import ContactInfo from "./pages/contactInfo";
import LocalizationManagement from "./pages/localization";
import SapCompanies from "./pages/sapCompanies";
import SalesOrderRequisitionConfig from "./pages/salesOrderRequisitionConfig";
import ExpiryReturnConfig from "./pages/expiryReturnConfig";
import { GrContactInfo } from "react-icons/gr";
import { FaRegBuilding } from "react-icons/fa";
export interface IRoute {
  type: "collapse" | "title" | "divider";
  key: string;
  title?: string;
  name?: string;
  route?: string;
  icon?: ReactElement;
  component?: React.JSX.Element;
  noCollapse?: boolean;
  collapse?: IRoute[];
}

const routes: IRoute[] = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <FaGauge size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  { type: "title", title: "Masters", key: "masters" },
  {
    type: "collapse",
    name: "Roles",
    key: "roles",
    route: "/roles",
    icon: <FaUserGroup size="12px" />,
    component: <RolesManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Staffs",
    key: "staffs",
    route: "/staffs",
    icon: <FaUserTie size="12px" />,
    component: <StaffTable />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <FaRegUser size="12px" />,
    component: <UserTable />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Promotions",
    key: "promotion",
    route: "/promotion",
    icon: <FaBullhorn size="12px" />,
    component: <PromotionManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Publications",
    key: "publication",
    route: "/publication",
    icon: <BsBook size="12px" />,
    component: <PublicationManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Services",
    key: "other-services",
    route: "/other-services",
    icon: <CiMedicalCase size="12px" />,
    component: <OtherService />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sale Order Requisition Configurations",
    key: "sale-order-requisition-configuration",
    route: "/sale-order-requisition-configuration",
    icon: <FaRegRectangleList size="12px" />,
    component: <SalesOrderRequisitionConfig />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Expiry Return Configuration",
    key: "expiry-return-configuration",
    route: "/expiry-return-configuration",
    icon: <FaRegRectangleList size="12px" />,
    component: <ExpiryReturnConfig />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "configurations",
    route: "/configurations",
    icon: <FcDataConfiguration size="12px" />,
    component: <SapConfig />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Notification Configuration",
    key: "notification-configuration",
    route: "/notification-configuration",
    icon: <FaEnvelope size="12px" />,
    component: <NotificationConfig />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "SAP Company Configurations",
    key: "sap-company-configurations",
    route: "/sap-company-configurations",
    icon: <FaRegBuilding size="12px" />,
    component: <SapCompanies />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Credit Segments",
    key: "credit-segments",
    route: "/credit-segments",
    icon: <PiLineSegments size="12px" />,
    component: <CreditSegmentCode />,
    noCollapse: true,
  },
  { type: "divider", key: "master-divider" },
  { type: "title", title: "Requests", key: "requests" },

  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    route: "/orders",
    icon: <FaRegRectangleList size="12px" />,
    component: <OrderRequests />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Return Sales Order",
    key: "return-sales-order",
    route: "/return-sales-order",
    icon: <BsReverseLayoutTextWindowReverse size="12px" />,
    component: <ReturnSalesOrder />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Order Reviews",
    key: "order-reviews",
    route: "/order-reviews",
    icon: <MdRemoveRedEye size="12px" />,
    component: <OrderReviews />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Credit Limits",
    key: "credit-limits",
    route: "/credit-limits",
    icon: <MdCreditScore size="12px" />,
    component: <CreditLimitRequests />,
    noCollapse: true,
  },
  { type: "divider", key: "request-divider" },
  { type: "title", title: "Support", key: "support" },
  {
    type: "collapse",
    name: "Contact Inquiries",
    key: "contact-inquiries",
    route: "/contact-inquiries",
    icon: <FaHeadset size="12px" />,
    component: <ContactUs />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customer Support",
    key: "customer-support",
    route: "/customer-support/:id?",
    icon: <RiMessage2Line size="12px" />,
    component: <Chat />,
    noCollapse: true,
  },
  { type: "divider", key: "support-divider" },
  { type: "title", title: "CMS", key: "cms" },
  {
    type: "collapse",
    name: "Privacy Policy",
    key: "privacy-policy",
    route: "/privacy-policy",
    icon: <MdOutlinePrivacyTip size="12px" />,
    component: <ManageCms type="privacy_policy" />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Terms & Conditions",
    key: "terms-and-conditions",
    route: "/terms-and-conditions",
    icon: <BsBlockquoteRight size="12px" />,
    component: <ManageCms type="terms_and_conditions" />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Contact info",
    key: "contact-info",
    route: "/contact-info",
    icon: <GrContactInfo size="12px" color="white" />,
    component: <ContactInfo />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Localization",
    key: "localization",
    route: "/localization",
    icon: <FcDataConfiguration size="12px" />,
    component: <LocalizationManagement />,
    noCollapse: true,
  },
];

export default routes;